var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_821_583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_821_583)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#545A6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_821_583",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_821_583",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAZAAAAGQBeJH1SwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAF0SURBVEiJrdVPS1RRGAbwX1NDOCoWaILSolxotGsTiqiLBJeu+gKBFO37AC3atekLJOgXkBb92+imTWsVFNESWwj9WQQFjU2Lc2Y4OuMN5twHDvfyvu95nnvf8/Cei/JRwQSu4RsaJXC2MIP9SNrAAWbLIh/F94S8uX5irFlUyRB4gCsd4r14VIbAjYLc9TIENgty2xm8BjAXn5+0n8ERrnZLfh9fBOdUcRPv8Deu95ID7oQqHmIZz3E3xofxOpK8xOCZfX3o/9/X1fDR6d+t4zF68Erwfdd4pr2fDfwWWtEVUhfNn1NzGQtlCBTNkK7nSyrw5pyaX8IBZ6MHH5zu/x8sCQZ4i3u5Ipci4Qpe4E6MD2Etiq4Ktk1RE2ZQNhbxWRjLVYxjXbBzHRvC3ZCFPkwLk/RQu62PhcsnG086kDfX02ZRzjS9VZBrtSlHYK8gd5DB28IIvmpvzw/JhZOLSewk5LuYSgsulCBSwe34voWTNPkPVBpdhpDqCNsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBlack);
export default __webpack_public_path__ + "static/media/share-black.5521af12cf9e187d0d3b8729a4a5b1fb.svg";
export { ForwardRef as ReactComponent };